<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        class="st3"
        d="M511.6,61.5C456,73.8,483.4,26.7,385.2,48.4c-20.1,4.4-39.4,13-57.6,23.4c21.6,7.5,40.9,17.9,58.6,28
		l123.6-20.4v18.5l-98.3,16.3c0,0,0,0,0,0L303.2,132v12.7v0.3L430.7,124l31.4-5.2v-0.3l58.5-9.7C582.9,78,612,97.4,612,97.4V0
		C547.6,14.2,567.3,49.3,511.6,61.5z"
      />
      <path class="st3" d="M462.9,133c6.9,0.3,13.6-0.7,20.3-3.4L462.9,133z" />
      <polygon
        class="st3"
        points="67.9,197.6 127.8,187.7 127.8,182.8 67.9,192.7 	"
      />
      <polygon
        class="st3"
        points="432.1,212.1 600.9,184.2 600.9,170.3 432.1,198.3 	"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SportsCover_c1",
  props: ["fill"],
};
</script>
